import { initClientAppState } from '@authy/lib-client/appState'
import { createGlobalInstance, getGlobalInstance } from '@authy/lib-client/utils/state'

import { WebAppState } from './WebAppState'

export let webAppState: WebAppState = getGlobalInstance('webAppState')

export const initWebAppState = (state: WebAppState) => {
    initClientAppState(state)
    webAppState = createGlobalInstance('webAppState', () => state)
}

export * from './WebAppState'
